module.exports = __webpack_public_path__ + "media/images/service-icon-04-4e51c29ceddf17c8e1f72baa11366c49.png";